<template>
  <vx-card no-shadow>
    <vs-popup fullscreen :title="popupTitle" :active.sync="popupActive" v-if="meta != null">
      <b>Details</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-input v-validate="'required|min:5'" data-vv-validate-on="blur" name="Full Name"
            label-placeholder="Full Name" v-model="meta.name" class="w-full" />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input v-validate="'required|min:3'" data-vv-validate-on="blur" name="Residential Address"
            label-placeholder="Residential Adrress" v-model="meta.address" class="w-full" />
        </div>
        <br />
      </div>
      <hr />
      <b>Role</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/5 w-half">
          <vs-input v-validate="'required|min:5'" data-vv-validate-on="blur" name="ID Number"
            label-placeholder="ID Number" v-model="meta.id_number" class="w-full" />
        </div>
        <div class="vx-col md:w-1/5 w-half">
          <vs-input v-validate="'required|min:5'" data-vv-validate-on="blur" name="Staff Number"
            label-placeholder="Staff Number" v-model="meta.staff_number" class="w-full" />
        </div>
        <div class="vx-col md:w-1/5 w-half">
          <br />
          <ejs-multiselect id="multiselect" maximumSelectionLength="1" :fields="parameterFieldsRole"
            v-model="meta.roleType" :dataSource="parameterOptionsRole" showClearButton="false" popupHeight="400px"
            mode="CheckBox" enableGroupCheckBox="false" showDropDownIcon="true" allowFiltering="true"
            filterType="contains" filterBarPlaceholder="Search" showSelectAll="false"
            placeholder="Role"></ejs-multiselect>
        </div>

        <br />
      </div>
      <hr />
      <br />
      <b>Pictures</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <label for="myvueDropZone">Upload Pictures</label>
          <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="(files, response) =>
        fileUploaderLocal(files, response, 'pictures')
      " v-on:vdropzone-removed-file="(file) => fileRemoverLocal(file, 'pictures')
      "></vue-dropzone>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label for="myvueDropZone">Uploaded File(s)</label>
          <div class="row" :key="index" v-for="(item, index) in meta.pictures">
            <a :href="'https://api.igeotechgps.com/uploads/' + item" target="_blank">{{ sanitizeLink(item) }}</a>
            &nbsp;
            <vs-button class="mb-base mr-3" size="small" type="border" icon-pack="feather" icon="icon icon-trash"
              @click="fileRemoverCloud('pictures', index)"></vs-button>
          </div>
        </div>
      </div>

      <!-- <hr />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Notification Channels</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-plus"
            @click="addContact('add')">Add Channel</vs-button>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-plus"
            @click="showChannels()">Select from Existing Channels</vs-button>
        </div>
      </div>
      <br />
      <div v-if="showExistingChannels">
        <div class="vx-row">
          <div class="vx-col md:w-1/8 w-half">
            <b>Current Channels</b>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <vs-table stripe :data="existingChannels" max-height="500">
              <template slot="thead">
                <vs-th width="5%">No.</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Detail</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>
                      <b>{{ indextr + 1 }}.</b></span>
                  </vs-td>
                  <vs-td>
                    {{ tr.type }}
                  </vs-td>
                  <vs-td>
                    {{ tr.detail }}
                  </vs-td>
                  <vs-td>
                    {{ tr.remark }}
                  </vs-td>
                  <vs-td>
                    <vs-button color="success" type="border" icon-pack="feather" icon="icon-check"
                      @click="addContactExisting(indextr)">Add</vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col md:w-1/3 w-full"></div>
          <br />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-2/3 w-full">
          <vs-table stripe :data="meta.channels" max-height="500">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Detail</vs-th>
              <vs-th>Remarks</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span>
                </vs-td>
                <vs-td>
                  <v-select placeholder="Select Type" clearable="false" :options="['Telegram', 'Email', 'SMS']"
                    v-model="meta.channels[indextr].type" />
                </vs-td>
                <vs-td>
                  <vs-input v-model="meta.channels[indextr].detail" label-placeholder="Details" class="w-full" />
                </vs-td>
                <vs-td>
                  <vs-input v-model="meta.channels[indextr].remark" label-placeholder="Remarks" class="w-full" />
                </vs-td>
                <vs-td>
                  <vs-button color="danger" type="border" icon-pack="feather" icon="icon-trash"
                    @click="removeContact(indextr)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <hr />
      <br />
      <hr />
      <br />
      <b>Notification Configuration</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input v-validate="'required|min:5'" data-vv-validate-on="blur" name="First Reminder"
            label-placeholder="First Reminder - Number of Days" v-model="meta.reminder_one_days" class="w-full" />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input v-validate="'required|min:5'" data-vv-validate-on="blur" name="Second Reminder"
            label-placeholder="Second Reminder - Number of Days" v-model="meta.reminder_two_days" class="w-full" />
        </div>
      </div> -->
      <br />
      <vs-button v-if="mode == 'add'" color="primary" type="filled" icon-pack="feather" icon="icon-plus"
        @click="postData('add')">Add New Crew</vs-button>
      <br />
      <div v-if="mode == 'update'">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            Created Profile: <b>{{ meta.create_time }}</b>
          </div>
          <div class="vx-col md:w-1/4 w-half" v-if="meta.update_time != null">
            Last Updated : <b>{{ meta.update_time }}</b>
          </div>
        </div>
        <br />

        <br /><br />
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-pen"
              @click="postData('update')">Update
              Crew Profile</vs-button>
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash"
              @click="postData('delete')">Delete
              Crew Profile</vs-button>
          </div>
        </div>
      </div>

      <br />
    </vs-popup>

    <vs-progress indeterminate color="primary" v-if="isLoading == true"></vs-progress>

    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-half">
        <vs-button size="small" @click="addTemplate">Add New Crew</vs-button>
      </div>
    </div>

    <br />

    <ejs-grid :dataSource="templateData" :allowExcelExport="true" :allowPdfExport="true" :toolbarClick="toolbarClick"
      :allowTextWrap="true" height="40vh" gridLines="Both" :filterSettings="filterOptions" :allowPaging="true"
      :searchSettings="searchOptions" :toolbar="toolbarOptions" ref="crewTemplateGrid" id="crewTemplateGrid"
      :pageSettings="pageSettings" :showColumnChooser="true" :allowSorting="true" :allowMultiSorting="true"
      :allowFiltering="true">
      <e-columns>
        <e-column field="no" headerText="No." textAlign="Left" width="80"></e-column>
        <e-column field="name" headerText="Name" textAlign="Left" width="150"></e-column>
        <e-column field="staff_id" headerText="Staff ID" textAlign="Left" width="150"></e-column>
        <e-column headerText="Picture" textAlign="Left" :template="cTemplate2" width="105"></e-column>
        <e-column field="update_time" headerText="Last Updated" textAlign="Left" width="100"></e-column>
        <e-column field="owner" headerText="Manager" textAlign="Left" width="100"></e-column>
        <e-column headerText="Manage" textAlign="Left" :template="cTemplate" width="100"></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate1.vue';
import columntempVue2 from './editButtonTemplate2.vue';
import vSelect from 'vue-select';
import axios from '@/axios.js';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { getBaseURL } from '@/config.js';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    vueDropzone: vue2Dropzone,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      isLoading: false,
      mode: 'add',
      popupActive: false,
      popupTitle: 'Add New Crew',
      templateData: [],
      userData: [
        {
          userGroup: 'Default',
          name: `${JSON.parse(localStorage.getItem('userInfo')).displayName
            } | ${JSON.parse(localStorage.getItem('userInfo')).username}`,
          id: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      groupData: [{ groupGroup: 'Default', name: 'All Units Assigned', id: 0 }],
      meta: null,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      searchOptions: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      cTemplate() {
        return { template: columntempVue };
      },
      cTemplate2() {
        return { template: columntempVue2 };
      },
      showExistingChannels: false,
      existingChannels: [],
      parameterFieldsRole: { text: 'label', value: 'val' },
      parameterOptionsRole:[
        {
          val:'Deckhands',
          label:'Deckhands'
        },
        {
          val:'Engineer',
          label:'Engineer'
        },
        {
          val:'Steward/Stewardess',
          label:'Steward/Stewardess'
        },
        {
          val:'Chef',
          label:'Chef'
        },
        {
          val:'Sailors',
          label:'Sailors'
        },
        {
          val:'Safety Officer',
          label:'Safety Officer'
        },
        {
          val:'Medical Officer',
          label:'Medical Officer'
        }
      ],
      parameterOptionsChannels: [
        {
          val: 'Telegram',
          label: 'Telegram',
        },
        {
          val: 'Email',
          label: 'Email',
        },
      ],
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  computed: {},
  methods: {
    fileUploaderLocal(files, response, key) {
      const x = response.path;
      const str = x.substring(25);
      this.meta[key].push(str);
    },
    fileRemoverCloud(key, index) {
      const self = this;
      self.meta[key].splice(index, 1);
    },
    fileRemoverLocal(file, key) {
      const self = this;
      const removedFile = file.upload.filename;
      const arr = self.meta[key];
      if (arr.length == 1) {
        self.meta[key] = [];
        return;
      }
      arr.forEach((element, i) => {
        const y = element.split('_', 4);
        if (y[3].includes(removedFile)) {
          self.meta[key].splice(i, 1);
        }
      });
    },
    sanitizeLink(link) {
      const y = link.split('_', 4);
      return `-> ${y[3]}`;
    },
    showChannels() {
      this.showExistingChannels = !this.showExistingChannels;
    },
    removeContact(index) {
      this.meta.channels.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Channel',
        color: 'success',
      });
    },
    addContact() {
      this.meta.channels.push({ type: '', detail: '', remark: '' });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Channel',
        color: 'success',
      });
    },
    addContactExisting(index) {
      this.meta.channels.push({
        type: this.existingChannels[index].type,
        detail: this.existingChannels[index].detail,
        remark: this.existingChannels[index].remark,
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Existing Channel',
        color: 'success',
      });
    },
    validateTemplate() {
      const self = this;
      return new Promise((resolve, reject) => {
      //  console.log(self.meta);
        if (self.meta.name.length < 5) {
          reject('Name field is mandatory. Minimum 5 characters.');
        }
        if (self.meta.id_number.length < 5) {
          reject('ID Number field is mandatory. Minimum 5 characters.');
        }
        if (self.meta.staff_number.length < 5) {
          reject('Staff Number field is mandatory. Minimum 5 characters.');
        }
        if (self.meta.roleType==null) {
          reject('Role Type field is mandatory. Select to Continue.');
        }
        else resolve(true);
      });
    },
    addTemplate() {
      const self = this;
      self.mode = 'add';
      self.popupTitle = 'Add New Crew';
      self.meta = {
        name: '',
        address: '',
        id_number:'',
        staff_number:'',
        roleType:null,
        pictures: [],
        createdById: self.userInfo.uid,
        createdByMeta: {
          uid: JSON.parse(localStorage.getItem('userInfo')).uid,
          email: JSON.parse(localStorage.getItem('userInfo')).email,
          username: JSON.parse(localStorage.getItem('userInfo')).username,
          userRole: JSON.parse(localStorage.getItem('userInfo')).userRole,
          displayName: JSON.parse(localStorage.getItem('userInfo')).displayName,
        },
      };
      self.popupActive = true;
    },
    editTemplate(data) {
      const self = this;
      self.mode = 'update';
      self.meta = JSON.parse(data.meta);
      self.popupTitle = `Update Crew ${self.meta.name}`;
      self.meta.id = data.id;
      self.popupActive = true;
    },
    getData() {
      const self = this;
     // console.log('called getddata')
      axios
        .post(
          `https://api.igeotechgps.com/api-vms/get-profiles/${self.userInfo.uid}/${self.userInfo.userRole}/Crew`,
          {
            adtlAccess: self.userInfo.access.actions.includes('vessel-agency'),
          },
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.templateData = response.data.templateData;
          //  console.log(self.templateData)
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    postData(type,data) {
      const self = this;
      let url;
      let successText;
      let successTitle;
      let failureText;
      let profile = 'Crew';
      if (type == `add`) {
        url = `https://api.igeotechgps.com/api-vms/add-profile`;
        successText = `Note: Newly added ${profile} could take upto 2 hours to activate alerts`;
        successTitle = `Added New ${profile}`;
        failureText = `Could not add ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
      }
      if (type == `update`) {
        url = `https://api.igeotechgps.com/api-vms/update-profile`;
        successText = `Note: Updated ${profile} configurations could take upto 2 hours to activate alerts`;
        successTitle = `Updated ${profile}`;
        failureText = `Could not Update ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
      }
      if (type == `delete`) {
        url = `https://api.igeotechgps.com/api-vms/delete-profile`;
        successText = `Note: Deleted ${profile} could take upto 2 hours to de-activate alerts`;
        successTitle = `Deleted ${profile}`;
        failureText = `Could not delete ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
        const text = `${profile} deletion action is PERMANENT & IRREVERSIBLE. Continue? `;
        if (confirm(text) == false) {
        }
      }
      if (type == `add` || type == `update`) {
        self
          .validateTemplate()
          .then((result) => {
            self.confirmPostData(
              url,
              successText,
              successTitle,
              failureText,
              profile,
              data
            );
          })
          .catch((error) => {
            self.$vs.notify({
              time: 5000,
              title: error,
              color: `warning`,
            });
          });
      } else {
        self.confirmPostData(
          url,
          successText,
          successTitle,
          failureText,
          profile,
        );
      }
    },
    confirmPostData(url, successText, successTitle, failureText, profile,data) {
      const self = this;
      let meta;
      if(data){
        meta = JSON.parse(data.meta);
      }
      else {
        meta = self.meta
      }
      axios
        .post(url, {
          userInfo: self.userInfo,
          type: profile,
          meta: meta,
        })
        .then(function (response) {
          self.popupActive = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              time: 10000,
              text: successText,
              title: successTitle,
              color: 'success',
            });
            self.getData();
            self.getData2();
          } else {
            self.$vs.notify({
              time: 8000,
              title: failureText,
              color: 'warning',
            });
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toolbarClick(args) {
      if (args.item.id === 'crewTemplateGrid_excelexport') {
        var exportProperties = {
          fileName: 'Crew - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.crewTemplateGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'crewTemplateGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Crew - Listing.pdf',
        };
        this.$refs.crewTemplateGrid.pdfExport(exportProperties);
      }
    },
    getData2() {
      const self = this;
      let uid = self.userInfo.uid;
      if (self.userInfo.access.actions.includes('events-staff')) {
        uid = 1;
      }
      self.$http
        .get(`admin/users/main/${uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            response.data.userData.forEach(function (element) {
              self.userData.push({
                id: element.id,
                name: element.username,
                userGroup: 'User Created',
              });
            });
            response.data.groupData.forEach(function (element) {
              self.groupData.push({
                id: element.id,
                name: element.name,
                groupGroup: 'User Created',
              });
            });
            axios
              .post('https://api.igeotechgps.com/api-events/get-channels', {
                userIds: self.userData,
              })
              .then(function (response) {
                if (response.status == 200 && response.data.success) {
                  self.existingChannels = response.data.existingChannels;
                } else if (response.data.error) {
                } else {
                }
              });
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) { });
    },
  },
  watch: {},
  mounted() {
    this.getData();
    this.getData2();
  },
};
</script>

<style>
.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}

#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
